import styled from 'styled-components';

export const CartPreviewEntryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${Styles.color.black};
  margin-bottom: 0.5rem;
`;
